"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Cereal = function Cereal(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5,12v2.3a8.946,8.946,0,0,1-8.946,8.946H10.446A8.946,8.946,0,0,1,1.5,14.3V12",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.828,9.011C21.468,9.805,22.5,10.857,22.5,12c0,2.485-4.7,4.5-10.5,4.5S1.5,14.485,1.5,12c0-2.645,5.324-4.757,11.629-4.475",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.549,10.915a.751.751,0,0,1-.361.537,4.732,4.732,0,0,1-3.556.394.751.751,0,0,1-.559-.984l3.245-9.249A1.294,1.294,0,0,1,19.844.787h0a1.293,1.293,0,0,1,.974,1.436Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.839,12a1.868,1.868,0,0,0-3.428,0",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.25,14.25a1.5,1.5,0,0,0-1.339-1.125,1.5,1.5,0,0,0-1.339,1.125",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }));
};
Cereal.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Cereal.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Cereal;